import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <p>
                                                The engineer running the Brooklyn Bridge project had to review
                                                his plans after that setback, but
                                                he didn’t let it prevent the bridge being built. He found a way
                                                of reinforcing the cables to meet
                                                safety requirements which kept the budget down and disrupted the
                                                project as little as possible.
                                            </p>

                                            <div className="border_subtitle">Changes and behaviour</div>
                                            <p><span className="subtiltereg">What kind of person am I; how will I respond to this setback?</span>
                                            </p>
                                            <p>Throughout our lives we all experience setbacks to what we most
                                                want to achieve. It could be
                                                finishing an important project to deadline at work or trying to
                                                get your children somewhere
                                                important on time. Your personality will affect how you react.
                                                When something unexpected looms
                                                in front of you, do you spin out of control or do you grab the
                                                steering wheel and steer out of the
                                                spin? How you deal with a problem determines its outcome. Try to
                                                remember that a setback is
                                                temporary and you can steer yourself back on track, with
                                                determination. If you don’t, you’re just
                                                setting yourself up for more setbacks ahead. Try to determine
                                                how much of the situation you can
                                                control and what you really cannot. For more information about
                                                how to make this decision
                                                effectively, see the tool ‘How to take control’.</p>
                                            <p>
                                                Step back and assess the situation. Make sure you take
                                                responsibility when appropriate and don’t
                                                blame others for your slip-ups. Is the setback really that
                                                significant or is it just a matter of applying
                                                yourself a little more to get things back on track? Never be shy
                                                about asking for help if you need
                                                it, including emotional support. You don’t have to be perfect –
                                                no one else is!
                                            </p>
                                            <div className="border_subtitle">Outcomes and decisions</div>
                                            <p>
                                                Being ‘self aware’ means allowing yourself to be objective about
                                                significant events and their
                                                impact on you. We tend to label any events as either ‘good’ or
                                                ‘bad’, depending on how you felt at
                                                the time. In fact, most experiences are neither wholly good nor
                                                bad – and our view of them can
                                                change in retrospect. We all have memories we can smile at, but
                                                which felt anything but amusing
                                                at the time.
                                            </p>
                                            <div className="border_subtitle">Planning and motivation</div>
                                            <p>
                                                Give yourself credit for small successes while working towards
                                                your main goal. Remember,
                                                however, that they may not come as regularly as you’d like – you
                                                may hit a plateau during which
                                                nothing seems to change. If so, give yourself time and be
                                                flexible rather than abandoning your
                                                goal altogether.
                                            </p>
                                            <p>
                                                Stick to your goal, not to your strategy. Perhaps, for example,
                                                a trainer at your gym suggests a
                                                different programme to what you thought you needed, but you find
                                                it works. Or, you may have
                                                been working towards a promotion but illness has prevented you
                                                from learning some of the
                                                necessary skills. Negotiate a new timetable for training and
                                                move your target date for the
                                                promotion. Having a time-bound goal is one of the best cures for
                                                procrastination!
                                            </p>
                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>SIGNIFICANT LIFE EVENTS EXERCISE
                                            </div>
                                            <div className="uiheading"><p>
                                                Think of some significant events. Start by considering one with
                                                happy associations where you
                                                achieved something that pleased you, without setbacks. Passing
                                                an exam, perhaps, or being
                                                promoted, accepting a new job offer or taking a trip abroad. Now
                                                ask yourself the following (and
                                                write your answers in the top box):
                                            </p></div>
                                            <ul className="greenbullet-list">
                                                <li>Were there any results from this action that were less than
                                                    satisfactory?
                                                </li>
                                                <li>What other options did I rule out for myself by the action
                                                    that I took?
                                                </li>
                                            </ul>
                                            <p>
                                                Now repeat the exercise (using the bottom box) with an event
                                                that didn’t turn out so well; one
                                                where you did encounter a setback. Maybe a poor performance at a
                                                meeting or interview, failing
                                                your driving test, the ending of a relationship?
                                            </p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}